const FloatingNotification = () => {
    return (
        <div className="fixed px-4 py-2 bottom-6 right-6 md:bottom-8 md:right-8 bg-white shadow-2xl rounded-lg border-2 border-vitagold z-50">
            <a href="/contact" className="font-vitaBody font-extrabold tracking-wider text-vitagrey text-xs uppercase">Book now</a>
        </div>
    );
}

export default FloatingNotification;